var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surey-page"},[(_vm.displaySurvey)?_c('taken-survey',{attrs:{"surveyProduct":_vm.surveyProduct,"surveyUserId":_vm.surveyUserId}}):(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }